import { config, isEmbedded } from '@/config';
import Client, { Redirect, shared } from '@shoplinedev/appbridge';
import { useEffect } from 'react';

export default function ExitIframe() {
  const app = Client.createApp({
    appKey: config.appKey || process.env.REACT_APP_API_KEY || '',
    host: shared.getHost(),
  });
  useEffect(() => {
    if (isEmbedded) {
      const redirect = Redirect.create(app);
      // eslint-disable-next-line no-restricted-globals
      const search = new URL(location.href).searchParams;
      console.log('redirectTo', search.get('redirectTo'));
      redirect.replaceTo(search.get('redirectTo') as string);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEmbedded, app]);
  return <></>;
}
